import { v4 as uuidv4 } from 'uuid';

/**
 * Generate UUID v4
 * @returns {string} UUID string
 */
export function generateUUID() {
  return uuidv4();
}

